import React from 'react';
import {
    Table,
    Row,
    Spin,
    Button,
    Popconfirm,
    Pagination,
} from 'antd';

import { asyncGet, actions, asyncGetAll, asyncDelete } from './reducers';
import { connect } from 'react-redux';
import SearchForm from './search.js';
import Edit from './edit.js';
import moment from 'moment';


class AgencyAnalysis extends React.Component {
    state = {
        selectedRowKeys: [],
    };
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        this.props.asyncGet();
        this.props.asyncGetAll();
    }

    changeHandle = (pagination, filters, sorter) => {
        this.props.changePagination(pagination);
        this.props.asyncGet();
    };
    /**
     * 分页器改变数据处理
     */
    handlePaginationChange = (current, pageSize) => {
        let pagination = {
            current,
            pageSize,
        };
        this.props.changePagination(pagination);
        this.props.asyncGet();
    };

    asyncDelete = record => {
        const { groupId } = record;
        this.props.asyncDelete({groupId}).then( this.props.asyncGet());

    }

    edit = record => {
        let {groupId, clientList} = record;
        clientList = JSON.stringify(clientList);
        clientList = JSON.parse(clientList);
        this.props.changeCurrentSelectId(groupId);
        this.props.getTransferData({selectedRowKeys: clientList});
        this.props.editShow();
    }

    renderAction = (text, record) => {
        // console.log(expanded, record);
        return (
            <div>
                <Button type="primary" style={{ marginRight: '5px' }} size="small" onClick={() => {
                    this.edit(record);
                }}>
                    编辑
                </Button>
                <Popconfirm
                    title='确认删除'
                    okText='确定'
                    cancelText='取消'
                    onConfirm={() => {
                        this.asyncDelete(record);
                    }}>
                    <Button type="danger" style={{ marginRight: '5px' }} size="small">
                        删除
                    </Button>
                </Popconfirm>
            </div>
        );
    };

    onSelectChange = selectedRowKeys => {
        this.props.deleteGroup(selectedRowKeys);
    }

    render() {
        let { list, uiStatus, pagination, deleteData } = this.props;
        let { total, current, pageSize } = pagination;
        let totalPage = Math.ceil(total / pageSize);
        let { isLoading } = uiStatus;

        const rowSelection = {
            selectedRowKeys: deleteData,
            onChange: this.onSelectChange,
        };

        const columns = [
            {
                title: '分组id',
                dataIndex: 'groupId',
                key: 'groupId',
            },
            {
                title: '分组名称',
                dataIndex: 'note',
                key: 'note',
            },
            {
                title: '分组类型',
                dataIndex: 'groupType',
                key: 'groupType',
            },
            {
                title: '客户端',
                dataIndex: 'clientList',
                key: 'clientList',
                render: text => {
                    return text && text.length ? <span>{text.join(',')}</span> : '';
                }
            },
            {
                title: '操作',
                dataIndex: 'action',
                key: 'action',
                render: (text, record, index) => {
                    return this.renderAction(text, record, index);
                },
            },
        ];

        return (
            <div style={{ marginBottom: '20px' }}>
                <Row style={{ marginTop: '10px', marginTop: '10px' }}>
                    <SearchForm {...this.props} />
                </Row>

                <Spin spinning={isLoading} tip="加载中...">
                    <Table
                        columns={columns}
                        dataSource={list}
                        defaultExpandAllRows={false}
                        rowSelection={rowSelection}
                        pagination={false}
                    />
                    <Row type="flex" justify="end">
                        <Pagination
                            style={{ padding: '10px 10px' }}
                            size="small"
                            showQuickJumper
                            pageSize={pageSize}
                            current={current}
                            total={total}
                            showTotal={(total, range) =>
                                `共 ${total ? total : '0'} 条记录，每页 ${pageSize} 条，这是第 ${totalPage
                                    ? current + '/' + totalPage
                                    : '1'} 页`}
                            showSizeChanger
                            pageSizeOptions={['40', '80', '120']}
                            onShowSizeChange={this.handlePaginationChange}
                            onChange={this.handlePaginationChange}
                        />
                    </Row>
                    <Edit />
                </Spin>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    list: state.clientManage.list,
    pagination: state.clientManage.pagination,
    uiStatus: state.clientManage.uiStatus,
    deleteData: state.clientManage.deleteData,
});
const mapDispatchToProps = dispatch => ({
    asyncGet: () => dispatch(asyncGet()),
    editShow: () => dispatch(actions.changeUiStatus({ isUpdateShow: true })),
    changeCurrentSelectId: id => dispatch(actions.changeCurrentSelectId(id)),
    deleteGroup: data => dispatch(actions.deleteGroup(data)),
    changePagination: data => dispatch(actions.changePagination(data)),
    getTransferData: data => dispatch(actions.getTransferData(data)),
    asyncGetAll: () => dispatch(asyncGetAll()),
    asyncDelete: groupId => dispatch(asyncDelete(groupId)),
});
export default connect(mapStateToProps, mapDispatchToProps)(AgencyAnalysis);






// WEBPACK FOOTER //
// ./pages/assist/clientManage/index.js